import { gql } from 'urql';

const SubmitFlexPayOverTimeOnboardingStep = gql`
  mutation SubmitFlexPayOverTimeOnboardingStep(
    $idempotencyId: IdempotencyToken!
    $input: SubmitFlexPayOverTimeOnboardingStepInput!
  ) {
    submitFlexPayOverTimeOnboardingStep(
      idempotencyId: $idempotencyId
      input: $input
    ) {
      __typename
      ... on SubmitFlexPayOverTimeOnboardingPaymentPlan {
        registrationInfoId
        agreementId
        paymentPlanDetails {
          summaryHeadline
          lineItems {
            label
            subLabel
            value
          }
          paymentSchedule {
            title
            scheduleItems {
              label
              amount {
                amount
                currency
                formatted
                formattedWithPlusPrefix
                formattedWithPlusPrefixOrAbs
              }
              dueDate
            }
            disclosureText
          }
        }
      }
      ... on SubmitFlexPayOverTimeOnboardingApplicationDeclined {
        declineReason
      }
      ... on SubmitFlexPayOverTimeOnboardingError {
        code
        title
        message
      }
    }
  }
`;

export default SubmitFlexPayOverTimeOnboardingStep;
